import { gql } from '@apollo/client';

export const LoginReplyFragment = gql`
    fragment LoginReply on LoginReply {
        accessToken
        refreshToken
    }
`;
